import { MONTH_OPTIONS } from '../../utils/constants';

export function DateRangeSelector({ months, onChange }) {
  return (
    <label className="flex items-center gap-2 text-sm text-slate-600">
      <span className="hidden sm:inline">Range</span>
      <select
        className="rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-sm font-medium text-slate-800"
        value={months}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {MONTH_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
